/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Either approved or denied.
 */
export const RecordDecisionRequestBodyDecision = {
  Approved: "approved",
  Denied: "denied",
} as const;
/**
 * Either approved or denied.
 */
export type RecordDecisionRequestBodyDecision = ClosedEnum<
  typeof RecordDecisionRequestBodyDecision
>;

export type RecordDecisionRequestBody = {
  /**
   * Either approved or denied.
   */
  decision: RecordDecisionRequestBodyDecision;
  /**
   * Principals the approval covers. Empty for a denial.
   */
  grantedPrincipalUrns?: Array<string> | undefined;
  /**
   * The approval request ID.
   */
  id: string;
  /**
   * Why the decision was made. This is the artifact cited when explaining the decision to the requester, so it cannot be blank.
   */
  rationale: string;
  /**
   * A research report this decision cites. Must belong to the request being decided.
   */
  researchReportId?: string | undefined;
};

/** @internal */
export const RecordDecisionRequestBodyDecision$outboundSchema: z.ZodMiniEnum<
  typeof RecordDecisionRequestBodyDecision
> = z.enum(RecordDecisionRequestBodyDecision);

/** @internal */
export type RecordDecisionRequestBody$Outbound = {
  decision: string;
  granted_principal_urns?: Array<string> | undefined;
  id: string;
  rationale: string;
  research_report_id?: string | undefined;
};

/** @internal */
export const RecordDecisionRequestBody$outboundSchema: z.ZodMiniType<
  RecordDecisionRequestBody$Outbound,
  RecordDecisionRequestBody
> = z.pipe(
  z.object({
    decision: RecordDecisionRequestBodyDecision$outboundSchema,
    grantedPrincipalUrns: z.optional(z.array(z.string())),
    id: z.string(),
    rationale: z.string(),
    researchReportId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      grantedPrincipalUrns: "granted_principal_urns",
      researchReportId: "research_report_id",
    });
  }),
);

export function recordDecisionRequestBodyToJSON(
  recordDecisionRequestBody: RecordDecisionRequestBody,
): string {
  return JSON.stringify(
    RecordDecisionRequestBody$outboundSchema.parse(recordDecisionRequestBody),
  );
}
